<template>
    <div class="list" v-if="expressList">
        <div class="li" v-for="(item,index) in expressList" :key="index" >
            <div>
                <div class="item-title"> <span class="item-type" v-if="item.status">{{ item.status }}</span> <span
                        class="item-time">{{ item.time }}</span> </div>
                <div class="item-text">
                    {{ item.context }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';
import types from '@/store/types';
export default {
    name: "express-info",
    props: {
        order_main_id:{},
    },
    data() {
        return {
            expressList:[]
        }
    },
    created(){
        this.getTermList()
    },
    methods: {
        toggle(visible) {
            this.visible = visible || !this.visible;
            this.$emit(this.visible ? 'show' : 'hide', {});
        },
        getTermList() {
            api[types.GET_EXPRESS_INFO]({ order_main_id:this.order_main_id }).then(res => {
                console.log('物流信息', res)
                let list = res.data.data || [];
                let oneText = '';
                for (let i = 0; i < list.length; i++) {
                    if (list[i].status == oneText) {
                        list[i].status = ''
                    } else {
                        oneText = list[i].status
                    }
                }
                this.expressList=list
            }).catch(err => {
                console.warn(err);
            });


        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

    .list {
        // width: 620px;
        margin-left: 10px;
        margin-top: 0px;

        // 66 40
        .li {
            padding-left: 20px;
            position: relative;
            // &:nth-child(1){
            //     .item-title{
            //         padding-top: 0;
            //     }
            // }
            &:before {
                position: absolute;
                top: 30px;
                left: 0;
                content: '';
                height: 100%;
                border-left: 1px dashed #ccc;
            }

            &:nth-last-child(1) {
                &:before {
                    height: 0;
                }
            }

            &:nth-child(1) {
                margin-top: 0;

                .item-title {
                    &:before {
                        background-color: #000;
                    }

                    .item-type {}
                }
            }
        }

        .item-type {
            font-size: 14px;
            margin-right: 24px;
            color: #000000;
            font-weight: 600;
        }

        .item-title {
            padding-top: 15px;
            position: relative;

            &:before {
                position: absolute;
                top: 28px;
                left: -23px;
                content: '';
                width: 7px;
                height: 7px;
                border-radius: 50%;
                border: 1px solid #000;
                background-color: #fff;
            }


        }

        .item-time {
            font-size: 12px;
            color: #666666;
            line-height: 34px;
        }

        .item-text {
            font-size: 12px;
            color: #333;
            line-height: 20px;
            max-width: 600px;
            box-sizing: border-box;
        }
    }

</style>